.root {
    padding-bottom: var(--mantine-spacing-xl);
}

.layout {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(16rem, 22rem);
    gap: var(--mantine-spacing-md);
    align-items: start;
}

@media (max-width: 62em) {
    .layout {
        grid-template-columns: minmax(0, 1fr);
    }
}

.mapArea {
    position: relative;
    min-width: 0;
    border: 1px solid var(--mantine-color-default-border);
    border-radius: var(--mantine-radius-md);
    overflow: hidden;
    background-color: var(--mantine-color-body);
}

.schematic {
    display: block;
    width: 100%;
    height: auto;
}

.schematicBackground {
    fill: var(--mantine-color-default-hover);
}

.pin {
    cursor: pointer;
    outline: none;
}

.pin:focus-visible circle {
    stroke-width: 5;
    stroke: var(--mantine-color-text);
}

.stopNumber,
.stopNumberOnFill {
    font-size: 12px;
    font-weight: 700;
    pointer-events: none;
}

.stopNumber {
    fill: var(--mantine-color-text);
}

.stopNumberOnFill {
    fill: var(--mantine-color-white);
}

.legLabel,
.legLabelLate,
.yardLabel {
    font-size: 12px;
    paint-order: stroke;
    stroke: var(--mantine-color-body);
    stroke-width: 4px;
    stroke-linejoin: round;
    pointer-events: none;
}

.legLabel,
.yardLabel {
    fill: var(--mantine-color-text);
}

.legLabelLate {
    fill: var(--mantine-color-red-6);
    font-weight: 700;
}

.yardLabel {
    font-weight: 700;
}

.yardMarker {
    stroke: var(--mantine-color-body);
    stroke-width: 2;
}

.googleMap {
    width: 100%;
    height: 32rem;
}

.mapLoading {
    position: absolute;
    inset: 0;
    background-color: color-mix(in srgb, var(--mantine-color-body) 60%, transparent);
}

@media (max-width: 48em) {
    .googleMap {
        height: 22rem;
    }
}

.googlePin {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 3px solid;
    font-size: 12px;
    font-weight: 700;
    box-shadow: 0 1px 3px rgb(0 0 0 / 40%);
    cursor: pointer;
}

.googleYard {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    border-radius: 6px;
    border: 2px solid var(--mantine-color-white);
    color: var(--mantine-color-white);
    font-size: 18px;
    font-weight: 700;
    box-shadow: 0 1px 3px rgb(0 0 0 / 40%);
}

.side {
    min-width: 0;
}

.legendSwatch {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 3px solid;
    vertical-align: middle;
    flex-shrink: 0;
}

.legendHome {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-radius: 3px;
    vertical-align: middle;
    flex-shrink: 0;
}

.legList {
    margin: 0;
    padding-left: 0;
    list-style: none;
}

.legItem {
    padding: 6px 0;
    border-bottom: 1px solid var(--mantine-color-default-border);
}

.legItem:last-child {
    border-bottom: none;
}
